
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import imgzx from './images/zx.jpg';
import imgwd from './images/wd.jpg';
import imgwll from './images/wll.jpg';
import imghzs from './images/hzs.jpg';
export default {
data()
{
return {
bb:'34343',
imgwd,
imgwll,
imgzx,
imghzs,
demo01_index:0,
}
}
,
components: {
Flexbox, FlexboxItem,XHeader, Swiper,
}
}



// WEBPACK FOOTER //
// ./src/project/vipnotifyProject/vipAppointmentDetila.vue